<template>
  <div>
    <div v-if="!isFetchingWidgets" class="widgets-container">
      <widget v-for="widget in widgets" :key="widget.title" :widget="widget" />
    </div>
    <div v-else class="widgets-container">
      <v-skeleton-loader
        v-for="n in 6"
        :key="n"
        type="card"
        width="141"
        height="100"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Widget from "@/components/Widget.vue";

export default {
  name: "DashboardTab",
  components: { Widget },
  computed: {
    ...mapState({
      currentUser: (state) => state.users.currentUser,
      widgets: (state) => state.widgets.widgets,
      isFetchingWidgets: (state) => state.widgets.isFetchingWidgets,
    }),
  },
  created() {
    this.$store.dispatch("widgets/fetchWidgets");
  },
};
</script>

<style lang="scss">
.widgets-container {
  display: grid;
  gap: 0.5rem;
  height: 100%;
  grid-template-columns: 1fr 1fr;
}
</style>
